import React from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  PageLayout,
  PageContent,
} from '@/components/PageLayout';
import { Badge } from '@/ui/badge';
import { ArrowLeft } from 'lucide-react';

const BlogPostPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  // In a real application, you would fetch the blog post content based on the slug
  // For now, we'll use mock data.
  const postContent = {
    title: 'Advanced Features You Should Know',
    author: 'Codii Team',
    date: 'June 15, 2024',
    tags: ['Productivity', 'AI', 'Code Quality'],
    content: `
      <p class="lead">This is the content for the blog post with slug: <strong>${slug}</strong>. In a real app, this would be fetched from a CMS or a static file and rendered as HTML.</p>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa.</p>
      <figure>
        <img src="https://images.unsplash.com/photo-1554629947-334ff61d85dc?q=80&w=2072&auto=format&fit=crop" alt="Mountain landscape" class="rounded-lg" />
        <figcaption>A caption for the image above.</figcaption>
      </figure>
      <h2>A Deeper Dive into Feature X</h2>
      <p>Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam. In scelerisque sem at dolor. Maecenas mattis. Sed convallis tristique sem. Proin ut ligula vel nunc egestas porttitor.</p>
      <blockquote>
        "This is an insightful blockquote that highlights a key takeaway from the post."
      </blockquote>
      <p>Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa. Fusce ac turpis quis ligula lacinia aliquet. Mauris ipsum. Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit.</p>
    `
  };

  return (
    <PageLayout>
      <PageContent>
        <article className="max-w-3xl mx-auto">
          <div className="mb-8">
            <Link to="/blog" className="inline-flex items-center text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Blog
            </Link>
          </div>

          <header className="mb-8">
            <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-2">
              <span>{postContent.date}</span>
              <span>•</span>
              <span>{postContent.author}</span>
            </div>
            <h1 className="text-4xl font-bold tracking-tight lg:text-5xl mb-4">
              {postContent.title}
            </h1>
            <div className="flex flex-wrap gap-2">
              {postContent.tags.map(tag => (
                <Badge key={tag} variant="secondary">{tag}</Badge>
              ))}
            </div>
          </header>

          <div
            className="prose prose-slate dark:prose-invert max-w-none prose-lg prose-p:text-foreground/80 prose-headings:text-foreground prose-a:text-primary prose-strong:text-foreground prose-blockquote:border-primary"
            dangerouslySetInnerHTML={{ __html: postContent.content }}
          />

        </article>
      </PageContent>
    </PageLayout>
  );
};

export default BlogPostPage;
